import { render, staticRenderFns } from "./LawyerDeductionsCosts.vue?vue&type=template&id=4d235b22"
import script from "./LawyerDeductionsCosts.vue?vue&type=script&lang=ts"
export * from "./LawyerDeductionsCosts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports